import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { useProcessApiClient } from '@/api/clients/useProcessApiClient.util.ts';
import { ProcessDto } from '@/api/generated';
import { QueryKeyEnum } from '@/api/model/QueryKey.enum.ts';

type Req = {
  processId?: string;
};

type Return = {
  isErrorGettingProcessDetails: boolean;
  isFetchingProcessDetails: boolean;
  isPendingProcessDetails: boolean;
  processDetails: ProcessDto | undefined;
};

export const useGetProcessDetails = (req: Req): Return => {
  const { processesApi } = useProcessApiClient();

  const { data, isError, isFetching, isPending } = useQuery<ProcessDto | undefined, AxiosError>({
    queryFn: async () => {
      if (!req.processId) return undefined;
      const { data } = await processesApi.getProcess(req.processId);
      return data;
    },
    queryKey: [QueryKeyEnum.PROCESS.DETAILS, req.processId],
  });

  return {
    isErrorGettingProcessDetails: isError,
    isFetchingProcessDetails: isFetching,
    isPendingProcessDetails: isPending,
    processDetails: data,
  };
};
